import axios from 'axios';

const API_URL = '/api/tenant/cash-closures';

export const fetchCashSessions = async () => {
  try {
    const response = await axios.get(`${API_URL}/sessions`);
    return response.data;
  } catch (error) {
    console.error('Error fetching cash sessions:', error);
    throw error;
  }
};

export const fetchCashSummary = async (moneyId) => {
  try {
    const response = await axios.get(`${API_URL}/summary/${moneyId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching cash summary for ${moneyId}:`, error);
    throw error;
  }
};

export const executeCashClosure = async (moneyId) => {
  try {
    const response = await axios.post(`${API_URL}/execute/${moneyId}`);
    return response.data;
  } catch (error) {
    console.error(`Error executing cash closure for ${moneyId}:`, error);
    throw error;
  }
};
